import Typography from '@components/std-components/Typography'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import formatNumberByLocale from '@utils/format-number-by-locale'
import get from 'lodash/get'
import React, { FC } from 'react'
import FieldSkeleton from '../../CellLoaders/FieldSkeleton'
import Cell from '../components/Cell'

const FieldData: FC<CellItem> = ({ rowData, column }) => {
  if (!rowData) {
    return <FieldSkeleton />
  }
  return (
    <Cell>
      <Typography variant='caption2'>
        {formatNumberByLocale(get(rowData, column.field))}
      </Typography>
    </Cell>
  )
}

export default FieldData
